export default {
  None: 'allowIssue',
  Warn: 'displayWarningButAllowIssue',
  Prevent: 'displayErrorAndPreventIssue',
}
